import { render, staticRenderFns } from "./SkillsLevels.vue?vue&type=template&id=4da89e50&scoped=true"
import script from "./SkillsLevels.vue?vue&type=script&lang=js"
export * from "./SkillsLevels.vue?vue&type=script&lang=js"
import style0 from "./SkillsLevels.vue?vue&type=style&index=0&id=4da89e50&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4da89e50",
  null
  
)

export default component.exports